import "regenerator-runtime/runtime"

import appConnectors from "@app/connectors/app-connectors"
import appRatingConnectors from "@app/connectors/app-rating-connectors"
import authConnectors from "@app/connectors/auth-connectors"
import historyConnectors from "@app/connectors/history-connectors"
import lifecycleConnectors from "@app/connectors/lifecycle-connectors"
import startupConnectors from "@app/connectors/startup-connectors"
import MenyNativeEvent from "@app/events/MenyNativeEvent"
import MenyWebAppEvent from "@app/events/MenyWebAppEvent"
import registerServiceWorker from "@app/service-worker/register"
import makeStore from "@app/store/make-store"
import * as tracking from "@app/tracking"
import inlineSvg from "@ng-mw/reol/utils/inlineSvg"
import { DebugLogger, GlobalSettings, NativeEventBridge } from "@ng-mw/shared-react-components"
import { createMemoryHistory } from "history"
import React from "react"
import { createRoot } from "react-dom/client"
import { Store } from "redux"

// oh noes
import "./shame"
// includes overrides
import "./resources/resources"

// Components
import PathNames from "@app/const/PathNames"
import { SyncUnleashContextWithUser, UnleashProvider } from "@app/feature-toggles"
import { RootState } from "@app/types"
import AppRoot from "@modules/framework/AppRoot"
import ErrorBoundary from "@modules/framework/ErrorBoundary"
import { Provider } from "react-redux"
import { Router } from "react-router"

// TS fix: Declare performanceTimings on window
declare global {
    interface Window {
        performanceTimings: {
            html: number
            js: number
            splash: number
        }
    }
}

// TS fix: Enable custom props in style
declare module "react" {
    interface CSSProperties {
        [key: `--${string}`]: string | number
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    interface HTMLAttributes<T> {
        inert?: boolean
    }
}

const store: Store<RootState> = makeStore() as any
const AppRouter = Router as React.ComponentType<
    React.PropsWithChildren<{ history: typeof history }>
>

NativeEventBridge.listen(MenyWebAppEvent.ReactCanMount, () => {
    const container = document.getElementById("app") as HTMLElement
    const root = createRoot(container)

    root.render(
        <ErrorBoundary>
            <Provider store={store}>
                <UnleashProvider
                    config={{
                        appName: "react-meny-app",
                        refreshInterval: 30,
                    }}
                >
                    <SyncUnleashContextWithUser />
                    <AppRouter history={history}>
                        <AppRoot />
                    </AppRouter>
                </UnleashProvider>
            </Provider>
        </ErrorBoundary>,
    )
    window.performanceTimings.splash = performance.now()
    NativeEventBridge.broadcastNative(MenyNativeEvent.LoadingComplete)
    DebugLogger.log(
        "Load-order-debug: LOADING COMPLETE! Time: ",
        window.performanceTimings.splash,
        "ms",
    )
    console.timeLog("Load-order-debug-TIMER")
    tracking.startUpMetricsSplash()

    setTimeout(() => {
        DebugLogger.log("Load-order-debug: rendered!")
        console.timeEnd("Load-order-debug-TIMER")
    })
})
DebugLogger.log("Load-order-debug: Listening for MenyWebAppEvent.ReactCanMount")

const history = createMemoryHistory({
    initialEntries: [PathNames.Home],
    initialIndex: 0,
})

if (process.env.MOCK === "true") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { mockConnectors } = require("@app/connectors/mock-connectors")
    mockConnectors(store)
}
authConnectors(store)

startupConnectors(store)

lifecycleConnectors(store, history)
appConnectors(store)
appRatingConnectors(store)
historyConnectors(store, history)

inlineSvg(GlobalSettings.inlineIconSetUrl, process.env.APP_VERSION)
registerServiceWorker(store)
